import { combineEpics } from "redux-observable";
import { p as produceQueryStringEpic, a as loadEmptyScorecardExtensionDataEpic, l as loadMetricPowerExtensionDataEpic, b as loadScriptGeneratorDataEpic } from "../../../Extensions.ducks-1ce34bb1.js";
import history from "@ane/core/lib/CreateHistory";
const rootEpic = combineEpics(
  produceQueryStringEpic(history),
  loadEmptyScorecardExtensionDataEpic.epic,
  loadMetricPowerExtensionDataEpic.epic,
  loadScriptGeneratorDataEpic.epic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
